module.exports = __webpack_public_path__ + "img/lessons.2971d040.svg";